import React from "react";

export const PoliticaDePrivacidad = () => {
  return (
    <section className="bg-gray-100 dark:bg-gray-900 py-12">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center text-gray-900 dark:text-white mb-8">
          Política de Privacidad
        </h1>
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md space-y-6">
          <p className="text-gray-700 dark:text-gray-300">
            <strong>ProductosCR.com</strong>, plataforma virtual que comercializa productos físicos/tangibles propios y de terceros (en adelante, PROVEEDORES), pone a su disposición esta <strong>Política de Privacidad</strong>. Su objetivo es informar a todos los USUARIOS acerca del uso de los datos proporcionados a través del sitio web 
            <a href="https://www.productoscr.com" className="text-blue-600 dark:text-blue-400 underline"> www.productoscr.com</a>. Se excluye aquella información que sea recolectada u obtenida por otros medios lícitos.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">1. Declaración General</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Al acceder o utilizar este sitio web, usted acepta esta <strong>Política de Privacidad</strong> y los <strong>Términos y Condiciones de Uso</strong>*. Si no está de acuerdo, no puede utilizar este sitio.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">2. Uso de la Información</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Los USUARIOS pueden acceder al sitio web y sus contenidos sin revelar datos personales. Sin embargo, algunos datos como nombre, información de contacto u otros pueden ser solicitados y utilizados por <strong>ProductosCR.com</strong> para:
          </p>
          <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2">
            <li>Gestionar el registro de usuarios y facilitar compras.</li>
            <li>Ofrecer servicios relacionados con productos o promociones.</li>
            <li>Mejorar los servicios prestados en el sitio web.</li>
          </ul>
          <p className="text-gray-700 dark:text-gray-300">
            <strong>ProductosCR.com</strong> no vende, alquila ni comparte información personal con terceros. Sin embargo, puede compartir datos con PROVEEDORES únicamente para actividades relacionadas con el sitio web y sus servicios.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">3. Seguridad de la Información</h2>
          <p className="text-gray-700 dark:text-gray-300">
            <strong>ProductosCR.com</strong> ha implementado medidas técnicas y organizativas para proteger la información de los USUARIOS y evitar su alteración, pérdida, acceso no autorizado o uso indebido. Sin embargo, no se garantiza la protección absoluta ante eventos fuera de control, como ataques de "hackers".
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">4. Uso de "Cookies"</h2>
          <p className="text-gray-700 dark:text-gray-300">
            El sitio web utiliza "cookies" y tecnologías similares para identificar la actividad de los usuarios y mejorar la experiencia de navegación. Los USUARIOS pueden configurar su navegador para rechazar las cookies o ser notificados cada vez que se envíen. Sin embargo, esta acción podría afectar el funcionamiento óptimo del sitio.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">5. Modificación de Datos Personales</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Los USUARIOS pueden actualizar, modificar o eliminar su información personal en cualquier momento, siempre que los datos proporcionados sean reales y veraces. Para realizar estos cambios, puede contactarnos en 
            <a href="mailto:info-sells@productoscr.com" className="text-blue-600 dark:text-blue-400 underline"> info-sells@productoscr.com</a>.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">6. Compartición de Datos</h2>
          <p className="text-gray-700 dark:text-gray-300">
            <strong>ProductosCR.com</strong> puede compartir información personal de los USUARIOS con PROVEEDORES, únicamente para actividades relacionadas con el sitio web. Esta información no será utilizada para otros fines sin el consentimiento del usuario, salvo cuando sea requerido por autoridades judiciales o administrativas.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">7. Revisión y Cambios</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Esta <strong>Política de Privacidad</strong> puede ser modificada sin previo aviso. Es responsabilidad de los USUARIOS revisar periódicamente este documento y los **Términos de Uso**. Al continuar utilizando el sitio web, el USUARIO acepta cualquier cambio realizado.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">8. Protección de Datos Personales</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Los datos personales se manejarán con la máxima confidencialidad para:
          </p>
          <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2">
            <li>Gestionar solicitudes administrativas o comerciales.</li>
            <li>Enviar ofertas, si así lo ha autorizado el USUARIO.</li>
            <li>Garantizar su seguridad mediante medidas técnicas y organizativas.</li>
          </ul>
          <p className="text-gray-700 dark:text-gray-300">
            El USUARIO declara que la información proporcionada es veraz y válida.
          </p>

          <p className="text-gray-700 dark:text-gray-300 italic">Última actualización: Noviembre 22, 2024</p>
        </div>
      </div>
    </section>
  );
};
